import createReactComponent from '../createReactComponent';
export default createReactComponent('flare', 'IconFlare', [
  ['path', { d: 'M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z', key: 'svg-0' }],
]);
